var _a;
/**
 * @hidden
 */
export var newMessageSendButton = 'newMessage.sendButton';
/**
 * @hidden
 */
export var newMessageOptionsButton = 'newMessage.optionsButton';
/**
 * @hidden
 */
export var newMessageMessageInput = 'newMessage.messageInput';
/**
 * @hidden
 */
export var avatarAlt = 'avatar.alt';
/**
 * @hidden
 */
export var messages = (_a = {},
    _a[newMessageSendButton] = 'Send',
    _a[newMessageOptionsButton] = 'Options',
    _a[newMessageMessageInput] = 'Message',
    _a[avatarAlt] = 'Avatar',
    _a);
